import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import JourneyProp from '../../journey/propTypes/journeyProp';
import Progress from '../list/enrolledItem/Progress';
import Anchor from '../../../commonComponents/Anchor';

const detailsLinkText = journey => {
  if (journey.progress === 0) {
    return 'start';
  }
  if (journey.progress > 0 && journey.progress < 100) {
    return 'continue';
  }
  return 'details';
};

function EnrolledJourney({ t, journey }) {
  const image = journey.image
    ? journey.image.thumb
    : '/images/no_image_upload.png';

  return (
    <div
      className={
        'm-portlet ' +
        'm-portlet--rounded ' +
        'm-portlet--rounded-force ' +
        'journey-enrolled-item'
      }
    >
      <div className="m-portlet__body journey-container-body">
        <div className="journey-info row">
          <div className="journey-image col-4">
            <img src={image} alt="journey" />
          </div>
          <div className="journey-name-and-description col-8">
            <div className="journey-header">
              <span className="journey-header-name">{journey.title}</span>
              <span className="journey-header-status">
                {t(`academy_courseStatus_${journey.status}`)}
              </span>
            </div>
            <div className="journey-description">{journey?.summary || ''}</div>
          </div>
        </div>
        <Progress progress={journey.progress} />
      </div>
      <div className="m-portlet__foot enrolled-journey-footer">
        <Anchor
          href={`/journey/${journey.slug}`}
          className="btn m-btn--pill btn-dynamic continue-button"
        >
          {t(detailsLinkText(journey))}
        </Anchor>
      </div>
    </div>
  );
}

EnrolledJourney.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
};

export default translate(EnrolledJourney);
